<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="630px"
    >
      <v-card>
        <v-card-title class="card-title">
          <v-layout wrap>
            <v-flex xs12>
              <h2 class="text-xs-left display-3 sz_grafit--text ma-0 mt-1">
                {{ modalTitleText }}
              </h2>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout
            v-if="isFamilyToDecision"
            column
          >
            <v-flex>
              <v-layout align-center>
                <v-icon
                  pr-5
                  mr-5
                  large
                  color="sz_red"
                >
                  warning
                </v-icon>
                <h2
                  class="text-xs-left f-16 sz_grafit--text ma-0 mt-1 ml-2 font-weight-regular"
                  v-html="$t('message.add_family_success_to_decision.text')"
                />
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout
            v-else-if="isOverwriteFamily"
            align-center
          />
          <v-layout
            v-else-if="isNative"
            align-center
          >
            <v-icon
              pr-5
              mr-5
              large
              color="green"
            >
              check_circle_outline
            </v-icon>
            <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-1 ml-2 font-weight-regular">
              {{ title }}
            </h2>
          </v-layout>
          <v-layout
            v-else
            column
          >
            <v-flex>
              <v-layout align-center>
                <v-icon
                  pr-5
                  mr-5
                  large
                  color="green"
                >
                  check_circle_outline
                </v-icon>
                <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-1 ml-2 font-weight-regular">
                  {{ title }}
                </h2>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout
            align-center
            justify-end
            :justify-space-between="$vuetify.breakpoint.smAndUp"
            wrap
            :justify-center="$vuetify.breakpoint.xs"
          >
            <v-flex
              shrink
              :mr-4="$vuetify.breakpoint.smAndUp"
              order-xs2
              order-sm1
              :mt-2="$vuetify.breakpoint.xs"
            >
              <router-link
                :to="{ name: 'families-to-accept' }"
                class="link_iconed"
              >
                <v-icon>chevron_left</v-icon>
                {{ $t('buttons.return_to_families_list') }}
              </router-link>
            </v-flex>
            <v-flex
              shrink
              order-xs1
              order-sm2
            >
              <v-btn
                color="sz_violet"
                @click="confirmAction"
              >
                <v-icon>add</v-icon>
                {{ $t('buttons.add_next_family') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <AppModal
      :visible="isGluedModal"
      :close-button="false"
      persistent
    >
      <template slot="content">
        <v-layout
          align-center
          mt-3
        >
          <v-flex
            shrink
            pa-2
            pl-0
          >
            <v-icon color="sz_red">
              warning
            </v-icon>
          </v-flex>
          <v-flex
            shrink
            pa-2
            pr-0
          >
            <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-1 font-weight-regular">
              {{ $t('alikes_families.p_e.glued_warning.title') }}
            </h2>
            <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-2 font-weight-regular">
              {{ $t('alikes_families.p_e.glued_warning.text') }}
            </h2>
          </v-flex>
        </v-layout>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          justify-space-between
        >
          <v-btn
            color="sz_violet"
            @click="closeGluedModal()"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
  </div>
</template>

<script>
import AppModal from '@/components/widgets/AppModal.vue';

export default {
    name: 'FamilySummary',
    components: { AppModal },
    data: () => ({
        dialog: false,
        isGluedModal: false
    }),
    computed: {
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        },
        title () {
            if (this.location == null) {
                return this.$t('message.add_family_without_rejon');
            }
            return this.isNative
                ? this.$t('message.add_family_success')
                : this.$t('message.add_family_success_not_native');
        },
        location () {
            return this.$store.getters['familyData/getLocation'];
        },
        isNative () {
            return this.location && this.location.native;
        },
        isFamilyToDecision () {
            const chosenOption =
        this.$store.getters['familyData/getSimilarityParameters'] &&
        this.$store.getters['familyData/getSimilarityParameters'].chosenOption;

            return chosenOption === 1;
        },
        isOverwriteFamily () {
            const chosenOption =
        this.$store.getters['familyData/getSimilarityParameters'] &&
        this.$store.getters['familyData/getSimilarityParameters'].chosenOption;

            return chosenOption === 2;
        },
        modalTitleText () {
            if (this.isFamilyToDecision) {
                return this.$t('message.add_family_success_to_decision.title');
            } else if (this.isOverwriteFamily) {
                return this.$t('message.add_family_overwrite_success');
            } else {
                return this.$t('message.add_family_success');
            }
        }
    },
    mounted () {
        if (this.$route.params.isGlued) {
            this.dialog = false;
            this.isGluedModal = true;
        } else {
            this.dialog = true;
        }
    },
    methods: {
        confirmAction () {
            this.$store.commit('familyData/clearFormData');
            this.$store.commit('familyData/setSimilarityParameters', null);
            this.$router.push({ name: 'add-family' });
        },
        closeGluedModal () {
            this.isGluedModal = false;
            this.dialog = true;
        }
    }
};
</script>

<style scoped></style>
